export default __webpack_public_path__ + "static/GBA_logo_b-f7e575cf4f899666a8dbd927d0f25c87.svg";